export const TIME_FORMAT = 'HH:MM';
export const TIME = 'HH:mm';
export const DATE_FORMAT = 'DD-MM-YYYY';
export const BIRTH_DATE_FORMAT = 'DD/MM/YY';
export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm';
